<template>
  <div>
    <label class="block text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5 sm:mb-2">
      {{ label }}
    </label>
    <select
      :value="modelValue"
      :required="required"
      class="w-full px-3 py-2 sm:py-2.5 text-sm border border-gray-300 dark:border-gray-700 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-800 dark:text-white transition-colors"
      @change="handleChange"
    >
      <slot />
    </select>
    <p
      v-if="hint"
      class="mt-1.5 text-xs text-gray-500 dark:text-gray-400 flex items-start gap-1.5"
    >
      <InformationCircleIcon class="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 mt-0.5" />
      <span>{{ hint }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from '@heroicons/vue/24/outline';

interface Props {
  modelValue: string;
  label: string;
  required?: boolean;
  hint?: string;
}

const props = withDefaults(defineProps<Props>(), {
  required: false,
  hint: ''
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

function handleChange(event: Event) {
  const target = event.target as HTMLSelectElement;
  emit('update:modelValue', target.value);
}
</script>
